import dayjs from 'dayjs';
// NOTE: We setup dayjs using `initialiseDayjs` so we don't need to initialise the dayjs plugins here.
// However, we need to import the dayjs plugins here to prevent type errors in the codebase.
import type {} from 'dayjs/plugin/advancedFormat';
import type {} from 'dayjs/plugin/customParseFormat';
import type {} from 'dayjs/plugin/duration';
import type {} from 'dayjs/plugin/isBetween';
import type {} from 'dayjs/plugin/isSameOrAfter';
import type {} from 'dayjs/plugin/relativeTime';
import type {} from 'dayjs/plugin/timezone';
import type {} from 'dayjs/plugin/utc';

export { initialiseDayjs, EN_VEHICLE_COUNTDOWN_LOCALE } from '@motorway/mw-dealer-shared-components/config';

export { dayjs };
export default dayjs;
